<mat-card appearance="outlined" class="p-0" *ngIf="(chargePlan | async) as chargePlan">
    <app-charge-plan-new (dateChangeEvent)="updateStartDate($event)" [plan]="chargePlan"></app-charge-plan-new>
</mat-card>
